import { render, staticRenderFns } from "./initiation.vue?vue&type=template&id=8ffc9d04&scoped=true&"
import script from "./initiation.vue?vue&type=script&lang=js&"
export * from "./initiation.vue?vue&type=script&lang=js&"
import style0 from "./initiation.vue?vue&type=style&index=0&id=8ffc9d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ffc9d04",
  null
  
)

export default component.exports